/**
 * Permission-based UI gating for the Portal (permission-first RBAC).
 *
 * The server resolves the user's scope-independent permission keys
 * (workspace/profile/admin) plus their time-away manage scope and ships them
 * on /api/portal/me; nav, routes and buttons gate on these helpers.
 */
import type { PortalPermissions, TimeAwayManageScope } from './views/portal/utils/portal-api.js'

export type PortalPermissionCategory = 'workspace' | 'profile' | 'admin'

export const emptyPortalPermissions = (): PortalPermissions => ({
    workspace: [],
    profile: [],
    admin: [],
})

export const hasPerm = (
    permissions: PortalPermissions,
    category: PortalPermissionCategory,
    key: string,
): boolean => permissions[category].includes(key)

/** Holds at least one admin capability — gates admin-ish UI surfaces. */
export const hasAnyAdmin = (permissions: PortalPermissions): boolean => permissions.admin.length > 0

/** Manager-style time-away UI (pending approvals etc.) needs beyond-self scope. */
export const canManageTimeAway = (scope: TimeAwayManageScope): boolean =>
    scope === 'reports' || scope === 'everyone'
